/* eslint-disable */
export default [
    {
        "key" : "Adak",
        "country" : "United States"
    }, {
        "key" : "Apia",
        "country" : "Samoa"
    }, {
        "key" : "Pago Pago",
        "country" : "United States"
    }, {
        "key" : "Alofi",
        "country" : "Niue"
    }, {
        "key" : "Avarua",
        "country" : "Cook Islands"
    }, {
        "key" : "Honolulu",
        "country" : "United States"
    }, {
        "key" : "Hilo",
        "country" : "United States"
    }, {
        "key" : "Anchorage",
        "country" : "United States"
    }, {
        "key" : "Papeete",
        "country" : "French Polynesia"
    }, {
        "key" : "Fairbanks",
        "country" : "United States"
    }, {
        "key" : "Sitka",
        "country" : "United States"
    }, {
        "key" : "Whitehorse",
        "country" : "Canada"
    }, {
        "key" : "Juneau",
        "country" : "United States"
    }, {
        "key" : "Adamstown",
        "country" : "United States"
    }, {
        "key" : "Vancouver",
        "country" : "Canada"
    }, {
        "key" : "Portland",
        "country" : "United States"
    }, {
        "key" : "San Francisco",
        "country" : "United States"
    }, {
        "key" : "Seattle",
        "country" : "United States"
    }, {
        "key" : "Sacramento",
        "country" : "United States"
    }, {
        "key" : "Los Angeles",
        "country" : "United States"
    }, {
        "key" : "Riverside",
        "country" : "United States"
    }, {
        "key" : "San Diego",
        "country" : "United States"
    }, {
        "key" : "Tijuana",
        "country" : "Mexico"
    }, {
        "key" : "Mexicali",
        "country" : "Mexico"
    }, {
        "key" : "Las Vegas",
        "country" : "United States"
    }, {
        "key" : "Yellowknife",
        "country" : "Canada"
    }, {
        "key" : "Calgary",
        "country" : "Canada"
    }, {
        "key" : "Edmonton",
        "country" : "Canada"
    }, {
        "key" : "Phoenix",
        "country" : "United States"
    }, {
        "key" : "Salt Lake City",
        "country" : "United States"
    }, {
        "key" : "Tucson",
        "country" : "United States"
    }, {
        "key" : "Hanga Roa",
        "country" : "Chile"
    }, {
        "key" : "Saskatoon",
        "country" : "Canada"
    }, {
        "key" : "Albuquerque",
        "country" : "United States"
    }, {
        "key" : "El Paso",
        "country" : "United States"
    }, {
        "key" : "Chihuahua",
        "country" : "Mexico"
    }, {
        "key" : "Denver",
        "country" : "United States"
    }, {
        "key" : "Durango",
        "country" : "Mexico"
    }, {
        "key" : "Regina",
        "country" : "Canada"
    }, {
        "key" : "Zapopan",
        "country" : "Mexico"
    }, {
        "key" : "Guadalajara",
        "country" : "Mexico"
    }, {
        "key" : "Monterrey",
        "country" : "Mexico"
    }, {
        "key" : "Mexico City",
        "country" : "Mexico"
    }, {
        "key" : "San Antonio",
        "country" : "United States"
    }, {
        "key" : "Puebla",
        "country" : "Mexico"
    }, {
        "key" : "Austin",
        "country" : "United States"
    }, {
        "key" : "Oklahoma City",
        "country" : "United States"
    }, {
        "key" : "Wichita",
        "country" : "United States"
    }, {
        "key" : "Winnipeg",
        "country" : "Canada"
    }, {
        "key" : "Dallas",
        "country" : "United States"
    }, {
        "key" : "Veracruz",
        "country" : "Mexico"
    }, {
        "key" : "Houston",
        "country" : "United States"
    }, {
        "key" : "Kansas City",
        "country" : "United States"
    }, {
        "key" : "Minneapolis",
        "country" : "United States"
    }, {
        "key" : "Quetzaltenango",
        "country" : "Guatemala"
    }, {
        "key" : "Guatemala City",
        "country" : "Guatemala"
    }, {
        "key" : "New Orleans",
        "country" : "United States"
    }, {
        "key" : "Memphis",
        "country" : "United States"
    }, {
        "key" : "Mérida",
        "country" : "Mexico"
    }, {
        "key" : "San Salvador",
        "country" : "El Salvador"
    }, {
        "key" : "Belmopan",
        "country" : "Belize"
    }, {
        "key" : "Belize City",
        "country" : "Belize"
    }, {
        "key" : "Milwaukee",
        "country" : "United States"
    }, {
        "key" : "Chicago",
        "country" : "United States"
    }, {
        "key" : "Tegucigalpa",
        "country" : "Honduras"
    }, {
        "key" : "Nashville",
        "country" : "United States"
    }, {
        "key" : "Managua",
        "country" : "Nicaragua"
    }, {
        "key" : "Indianapolis",
        "country" : "United States"
    }, {
        "key" : "Louisville",
        "country" : "United States"
    }, {
        "key" : "Cincinnati",
        "country" : "United States"
    }, {
        "key" : "Atlanta",
        "country" : "United States"
    }, {
        "key" : "San José",
        "country" : "Costa Rica"
    }, {
        "key" : "Detroit",
        "country" : "United States"
    }, {
        "key" : "Columbus",
        "country" : "United States"
    }, {
        "key" : "Tampa",
        "country" : "United States"
    }, {
        "key" : "Havana",
        "country" : "Cuba"
    }, {
        "key" : "Cleveland",
        "country" : "United States"
    }, {
        "key" : "Jacksonville",
        "country" : "United States"
    }, {
        "key" : "George Town",
        "country" : "Malaysia"
    }, {
        "key" : "Charlotte",
        "country" : "United States"
    }, {
        "key" : "Miami",
        "country" : "United States"
    }, {
        "key" : "Pittsburgh",
        "country" : "United States"
    }, {
        "key" : "Guayaquil",
        "country" : "Ecuador"
    }, {
        "key" : "Panama City",
        "country" : "Panama"
    }, {
        "key" : "Toronto",
        "country" : "Canada"
    }, {
        "key" : "Buffalo",
        "country" : "United States"
    }, {
        "key" : "Raleigh",
        "country" : "United States"
    }, {
        "key" : "Quito",
        "country" : "Ecuador"
    }, {
        "key" : "Rochester",
        "country" : "United States"
    }, {
        "key" : "Nassau",
        "country" : "The Bahamas"
    }, {
        "key" : "Washington",
        "country" : "United States"
    }, {
        "key" : "Lima",
        "country" : "Peru"
    }, {
        "key" : "Kingston",
        "country" : "Jamaica"
    }, {
        "key" : "Baltimore",
        "country" : "United States"
    }, {
        "key" : "Cali",
        "country" : "Colombia"
    }, {
        "key" : "Virginia Beach",
        "country" : "United States"
    }, {
        "key" : "Ottawa",
        "country" : "Canada"
    }, {
        "key" : "Medellín",
        "country" : "Colombia"
    }, {
        "key" : "Cartagena",
        "country" : "Colombia"
    }, {
        "key" : "Philadelphia",
        "country" : "United States"
    }, {
        "key" : "Barranquilla",
        "country" : "Colombia"
    }, {
        "key" : "Forked River",
        "country" : "United States"
    }, {
        "key" : "Jersey City",
        "country" : "United States"
    }, {
        "key" : "Bogotá",
        "country" : "Colombia"
    }, {
        "key" : "Montreal",
        "country" : "Canada"
    }, {
        "key" : "Iquitos",
        "country" : "Peru"
    }, {
        "key" : "Valdivia",
        "country" : "Chile"
    }, {
        "key" : "Concepción",
        "country" : "Chile"
    }, {
        "key" : "Cusco",
        "country" : "Peru"
    }, {
        "key" : "Maracaibo",
        "country" : "Venezuela"
    }, {
        "key" : "Valparaíso",
        "country" : "Chile"
    }, {
        "key" : "Arequipa",
        "country" : "Peru"
    }, {
        "key" : "Providence",
        "country" : "United States"
    }, {
        "key" : "La Serena",
        "country" : "Chile"
    }, {
        "key" : "Cockburn Town",
        "country" : "Turks and Caicos Islands"
    }, {
        "key" : "Boston",
        "country" : "United States"
    }, {
        "key" : "Punta Arenas",
        "country" : "Chile"
    }, {
        "key" : "Santiago",
        "country" : "Chile"
    }, {
        "key" : "Antofagasta",
        "country" : "Chile"
    }, {
        "key" : "Iquique",
        "country" : "Chile"
    }, {
        "key" : "Oranjestad",
        "country" : "Aruba"
    }, {
        "key" : "Santo Domingo",
        "country" : "Dominican Republic"
    }, {
        "key" : "Rio Branco",
        "country" : "Brazil"
    }, {
        "key" : "Willemstad",
        "country" : "Netherlands Antilles"
    }, {
        "key" : "Calama",
        "country" : "Chile"
    }, {
        "key" : "Mendoza",
        "country" : "Argentina"
    }, {
        "key" : "Iqaluit",
        "country" : "Canada"
    }, {
        "key" : "Ushuaia",
        "country" : "Argentina"
    }, {
        "key" : "La Paz",
        "country" : "Bolivia"
    }, {
        "key" : "Puerto Williams",
        "country" : "Chile"
    }, {
        "key" : "Caracas",
        "country" : "Venezuela"
    }, {
        "key" : "Fredericton",
        "country" : "Canada"
    }, {
        "key" : "San Juan",
        "country" : "Puerto Rico"
    }, {
        "key" : "Saint John",
        "country" : "Grenada"
    }, {
        "key" : "Sucre",
        "country" : "Bolivia"
    }, {
        "key" : "Charlotte Amalie",
        "country" : "United States"
    }, {
        "key" : "Hamilton",
        "country" : "Bermuda"
    }, {
        "key" : "Road Town",
        "country" : "British Virgin Islands"
    }, {
        "key" : "Córdoba",
        "country" : "Argentina"
    }, {
        "key" : "Porto Velho",
        "country" : "Brazil"
    }, {
        "key" : "Charlottetown",
        "country" : "Canada"
    }, {
        "key" : "The Valley",
        "country" : "Anguilla"
    }, {
        "key" : "Basse-Terre",
        "country" : "Guadeloupe"
    }, {
        "key" : "Bahía Blanca",
        "country" : "Argentina"
    }, {
        "key" : "St. John's",
        "country" : "Canada"
    }, {
        "key" : "San Fernando",
        "country" : "Trinidad and Tobago"
    }, {
        "key" : "Roseau",
        "country" : "Dominica"
    }, {
        "key" : "Chaguanas",
        "country" : "Trinidad and Tobago"
    }, {
        "key" : "Kingstown",
        "country" : "Saint Vincent and the Grenadines"
    }, {
        "key" : "Castries",
        "country" : "St. Lucia"
    }, {
        "key" : "Rosario",
        "country" : "Argentina"
    }, {
        "key" : "Boa Vista",
        "country" : "Brazil"
    }, {
        "key" : "Manaus",
        "country" : "Brazil"
    }, {
        "key" : "Bridgetown",
        "country" : "Barbados"
    }, {
        "key" : "Buenos Aires",
        "country" : "Argentina"
    }, {
        "key" : "Stanley",
        "country" : "Hong Kong"
    }, {
        "key" : "Asunción",
        "country" : "Paraguay"
    }, {
        "key" : "Saint-Pierre",
        "country" : "Réunion"
    }, {
        "key" : "Montevideo",
        "country" : "Uruguay"
    }, {
        "key" : "Cuiabá",
        "country" : "Brazil"
    }, {
        "key" : "Paramaribo",
        "country" : "Suriname"
    }, {
        "key" : "Campo Grande",
        "country" : "Brazil"
    }, {
        "key" : "Chuí",
        "country" : "Brazil"
    }, {
        "key" : "Pelotas",
        "country" : "Brazil"
    }, {
        "key" : "Cayenne",
        "country" : "French Guiana"
    }, {
        "key" : "Nuuk",
        "country" : "Greenland"
    }, {
        "key" : "Porto Alegre",
        "country" : "Brazil"
    }, {
        "key" : "Macapá",
        "country" : "Brazil"
    }, {
        "key" : "Assis",
        "country" : "Italy"
    }, {
        "key" : "Curitiba",
        "country" : "Brazil"
    }, {
        "key" : "Belém",
        "country" : "Brazil"
    }, {
        "key" : "Brasília",
        "country" : "Brazil"
    }, {
        "key" : "Campinas",
        "country" : "Brazil"
    }, {
        "key" : "São Paulo",
        "country" : "Brazil"
    }, {
        "key" : "Vitória",
        "country" : "Brazil"
    }, {
        "key" : "Ilhéus",
        "country" : "Brazil"
    }, {
        "key" : "Fortaleza",
        "country" : "Brazil"
    }, {
        "key" : "Maceió",
        "country" : "Brazil"
    }, {
        "key" : "Recife",
        "country" : "Brazil"
    }, {
        "key" : "Ponta Delgada",
        "country" : "Portugal"
    }, {
        "key" : "Praia",
        "country" : "Brazil"
    }, {
        "key" : "Reykjavík",
        "country" : "Iceland"
    }, {
        "key" : "Dakar",
        "country" : "Senegal"
    }, {
        "key" : "Thiès",
        "country" : "Senegal"
    }, {
        "key" : "Serekunda",
        "country" : "The Gambia"
    }, {
        "key" : "Brikama",
        "country" : "The Gambia"
    }, {
        "key" : "Banjul",
        "country" : "The Gambia"
    }, {
        "key" : "Nouakchott",
        "country" : "Mauritania"
    }, {
        "key" : "Bissau",
        "country" : "Guinea-Bissau"
    }, {
        "key" : "Conakry",
        "country" : "Guinea"
    }, {
        "key" : "Freetown",
        "country" : "Sierra Leone"
    }, {
        "key" : "El Aaiún",
        "country" : "Western Sahara"
    }, {
        "key" : "Monrovia",
        "country" : "Liberia"
    }, {
        "key" : "Lisbon",
        "country" : "Portugal"
    }, {
        "key" : "Porto",
        "country" : "Brazil"
    }, {
        "key" : "Bamako",
        "country" : "Mali"
    }, {
        "key" : "Casablanca",
        "country" : "Morocco"
    }, {
        "key" : "Koulikoro",
        "country" : "Mali"
    }, {
        "key" : "Rabat",
        "country" : "Morocco"
    }, {
        "key" : "Tórshavn",
        "country" : "Faroe Islands"
    }, {
        "key" : "Dublin",
        "country" : "Ireland"
    }, {
        "key" : "Seville",
        "country" : "Spain"
    }, {
        "key" : "Belfast",
        "country" : "United Kingdom"
    }, {
        "key" : "Jamestown",
        "country" : "United States"
    }, {
        "key" : "Gibraltar",
        "country" : "Gibraltar"
    }, {
        "key" : "Yamoussoukro",
        "country" : "Côte d'Ivoire"
    }, {
        "key" : "Douglas",
        "country" : "Australia"
    }, {
        "key" : "Málaga",
        "country" : "Spain"
    }, {
        "key" : "Glasgow",
        "country" : "United Kingdom"
    }, {
        "key" : "Abidjan",
        "country" : "Côte d'Ivoire"
    }, {
        "key" : "Madrid",
        "country" : "Spain"
    }, {
        "key" : "Cardiff",
        "country" : "United Kingdom"
    }, {
        "key" : "Edinburgh",
        "country" : "United Kingdom"
    }, {
        "key" : "Timbuktu",
        "country" : "Mali"
    }, {
        "key" : "Liverpool",
        "country" : "United Kingdom"
    }, {
        "key" : "Bilbao",
        "country" : "Spain"
    }, {
        "key" : "Manchester",
        "country" : "United Kingdom"
    }, {
        "key" : "Aberdeen",
        "country" : "United Kingdom"
    }, {
        "key" : "Birmingham",
        "country" : "United Kingdom"
    }, {
        "key" : "Leeds",
        "country" : "United Kingdom"
    }, {
        "key" : "Nantes",
        "country" : "France"
    }, {
        "key" : "Ouagadougou",
        "country" : "Burkina Faso"
    }, {
        "key" : "Tamale",
        "country" : "Ghana"
    }, {
        "key" : "Valencia",
        "country" : "Spain"
    }, {
        "key" : "Accra",
        "country" : "Ghana"
    }, {
        "key" : "London",
        "country" : "United Kingdom"
    }, {
        "key" : "Greenwich",
        "country" : "United Kingdom"
    }, {
        "key" : "Lomé",
        "country" : "Togo"
    }, {
        "key" : "Toulouse",
        "country" : "France"
    }, {
        "key" : "Ibiza",
        "country" : "Spain"
    }, {
        "key" : "Niamey",
        "country" : "Niger"
    }, {
        "key" : "Barcelona",
        "country" : "Spain"
    }, {
        "key" : "Paris",
        "country" : "France"
    }, {
        "key" : "Cotonou",
        "country" : "Benin"
    }, {
        "key" : "Porto-Novo",
        "country" : "Benin"
    }, {
        "key" : "Palma",
        "country" : "Spain"
    }, {
        "key" : "Algiers",
        "country" : "Algeria"
    }, {
        "key" : "Lagos",
        "country" : "Nigeria"
    }, {
        "key" : "Ibadan",
        "country" : "Nigeria"
    }, {
        "key" : "The Hague",
        "country" : "Netherlands"
    }, {
        "key" : "Brussels",
        "country" : "Belgium"
    }, {
        "key" : "Antwerp",
        "country" : "Belgium"
    }, {
        "key" : "Rotterdam",
        "country" : "Netherlands"
    }, {
        "key" : "Lyon",
        "country" : "France"
    }, {
        "key" : "Amsterdam",
        "country" : "Netherlands"
    }, {
        "key" : "Marseille",
        "country" : "France"
    }, {
        "key" : "Bergen",
        "country" : "Norway"
    }, {
        "key" : "Geneva",
        "country" : "Switzerland"
    }, {
        "key" : "São Tomé",
        "country" : "Brazil"
    }, {
        "key" : "Düsseldorf",
        "country" : "Germany"
    }, {
        "key" : "Cologne",
        "country" : "Germany"
    }, {
        "key" : "Cannes",
        "country" : "France"
    }, {
        "key" : "Nice",
        "country" : "France"
    }, {
        "key" : "Monaco",
        "country" : "Monaco"
    }, {
        "key" : "Bern",
        "country" : "Brazil"
    }, {
        "key" : "Abuja",
        "country" : "Nigeria"
    }, {
        "key" : "Enugu",
        "country" : "Nigeria"
    }, {
        "key" : "Turin",
        "country" : "Italy"
    }, {
        "key" : "Strasbourg",
        "country" : "France"
    }, {
        "key" : "Kano",
        "country" : "Nigeria"
    }, {
        "key" : "Zürich",
        "country" : "Switzerland"
    }, {
        "key" : "Frankfurt",
        "country" : "Germany"
    }, {
        "key" : "Malabo",
        "country" : "Philippines"
    }, {
        "key" : "Stuttgart",
        "country" : "Germany"
    }, {
        "key" : "Milan",
        "country" : "Italy"
    }, {
        "key" : "Libreville",
        "country" : "Gabon"
    }, {
        "key" : "Vaduz",
        "country" : "Liechtenstein"
    }, {
        "key" : "Douala",
        "country" : "Cameroon"
    }, {
        "key" : "Hanover",
        "country" : "Germany"
    }, {
        "key" : "Hamburg",
        "country" : "Germany"
    }, {
        "key" : "Tunis",
        "country" : "Tunisia"
    }, {
        "key" : "Aarhus",
        "country" : "Denmark"
    }, {
        "key" : "Oslo",
        "country" : "Norway"
    }, {
        "key" : "Innsbruck",
        "country" : "Austria"
    }, {
        "key" : "Yaoundé",
        "country" : "Cameroon"
    }, {
        "key" : "Munich",
        "country" : "Germany"
    }, {
        "key" : "Gothenburg",
        "country" : "Sweden"
    }, {
        "key" : "Leipzig",
        "country" : "Germany"
    }, {
        "key" : "Rome",
        "country" : "Italy"
    }, {
        "key" : "Copenhagen",
        "country" : "Denmark"
    }, {
        "key" : "Malmö",
        "country" : "Sweden"
    }, {
        "key" : "Salzburg",
        "country" : "Austria"
    }, {
        "key" : "Tripoli",
        "country" : "Libya"
    }, {
        "key" : "Luanda",
        "country" : "Angola"
    }, {
        "key" : "Berlin",
        "country" : "Germany"
    }, {
        "key" : "Dresden",
        "country" : "Germany"
    }, {
        "key" : "Naples",
        "country" : "Italy"
    }, {
        "key" : "Linz",
        "country" : "Austria"
    }, {
        "key" : "Prague",
        "country" : "Czech Republic"
    }, {
        "key" : "Sabha",
        "country" : "Libya"
    }, {
        "key" : "Birkirkara",
        "country" : "Malta"
    }, {
        "key" : "Ljubljana",
        "country" : "Slovenia"
    }, {
        "key" : "Valletta",
        "country" : "Malta"
    }, {
        "key" : "N'Djamena",
        "country" : "Chad"
    }, {
        "key" : "Brazzaville",
        "country" : "Republic of the Congo"
    }, {
        "key" : "Kinshasa",
        "country" : "Democratic Republic of the Congo"
    }, {
        "key" : "Graz",
        "country" : "Austria"
    }, {
        "key" : "Longyearbyen",
        "country" : "Svalbard and Jan Mayen"
    }, {
        "key" : "Zagreb",
        "country" : "Croatia"
    }, {
        "key" : "Vienna",
        "country" : "Austria"
    }, {
        "key" : "Bratislava",
        "country" : "Slovakia"
    }, {
        "key" : "Stockholm",
        "country" : "Sweden"
    }, {
        "key" : "Sarajevo",
        "country" : "Bosnia and Herzegovina"
    }, {
        "key" : "Cape Town",
        "country" : "South Africa"
    }, {
        "key" : "Bangui",
        "country" : "Central African Republic"
    }, {
        "key" : "Budapest",
        "country" : "Hungary"
    }, {
        "key" : "Podgorica",
        "country" : "Montenegro"
    }, {
        "key" : "Tirana",
        "country" : "Albania"
    }, {
        "key" : "Kraków",
        "country" : "Poland"
    }, {
        "key" : "Belgrade",
        "country" : "Serbia"
    }, {
        "key" : "Kaliningrad",
        "country" : "Russia"
    }, {
        "key" : "Warsaw",
        "country" : "Poland"
    }, {
        "key" : "Pristina",
        "country" : "Kosovo"
    }, {
        "key" : "Skopje",
        "country" : "Macedonia"
    }, {
        "key" : "Sofia",
        "country" : "Bulgaria"
    }, {
        "key" : "Athens",
        "country" : "Greece"
    }, {
        "key" : "Tampere",
        "country" : "Finland"
    }, {
        "key" : "Lviv",
        "country" : "Ukraine"
    }, {
        "key" : "Riga",
        "country" : "Latvia"
    }, {
        "key" : "Espoo",
        "country" : "Finland"
    }, {
        "key" : "Tallinn",
        "country" : "Estonia"
    }, {
        "key" : "Helsinki",
        "country" : "Finland"
    }, {
        "key" : "Vilnius",
        "country" : "Lithuania"
    }, {
        "key" : "Port Elizabeth",
        "country" : "South Africa"
    }, {
        "key" : "Livingstone",
        "country" : "Zambia"
    }, {
        "key" : "Gaborone",
        "country" : "Botswana"
    }, {
        "key" : "Bucharest",
        "country" : "Romania"
    }, {
        "key" : "Bloemfontein",
        "country" : "South Africa"
    }, {
        "key" : "Tartu",
        "country" : "Syria"
    }, {
        "key" : "Lubumbashi",
        "country" : "Democratic Republic of the Congo"
    }, {
        "key" : "Maseru",
        "country" : "Lesotho"
    }, {
        "key" : "Francistown",
        "country" : "Botswana"
    }, {
        "key" : "Minsk",
        "country" : "Belarus"
    }, {
        "key" : "Johannesburg",
        "country" : "South Africa"
    }, {
        "key" : "Pretoria",
        "country" : "South Africa"
    }, {
        "key" : "Lusaka",
        "country" : "Zambia"
    }, {
        "key" : "Ndola",
        "country" : "Zambia"
    }, {
        "key" : "Bulawayo",
        "country" : "Zimbabwe"
    }, {
        "key" : "Istanbul",
        "country" : "Turkey"
    }, {
        "key" : "Bursa",
        "country" : "Turkey"
    }, {
        "key" : "Bujumbura",
        "country" : "Burundi"
    }, {
        "key" : "Tiraspol",
        "country" : "Moldova"
    }, {
        "key" : "Alexandria",
        "country" : "Egypt"
    }, {
        "key" : "Kigali",
        "country" : "Rwanda"
    }, {
        "key" : "Saint Petersburg",
        "country" : "Russia"
    }, {
        "key" : "Odessa",
        "country" : "Ukraine"
    }, {
        "key" : "Harare",
        "country" : "Zimbabwe"
    }, {
        "key" : "Durban",
        "country" : "South Africa"
    }, {
        "key" : "Mbabane",
        "country" : "Swaziland"
    }, {
        "key" : "Lobamba",
        "country" : "Swaziland"
    }, {
        "key" : "Cairo",
        "country" : "Egypt"
    }, {
        "key" : "Manzini",
        "country" : "Swaziland"
    }, {
        "key" : "Port Said",
        "country" : "Egypt"
    }, {
        "key" : "Konya",
        "country" : "Turkey"
    }, {
        "key" : "Omdurman",
        "country" : "Sudan"
    }, {
        "key" : "Khartoum",
        "country" : "Sudan"
    }, {
        "key" : "Suez",
        "country" : "Egypt"
    }, {
        "key" : "Maputo",
        "country" : "Mozambique"
    }, {
        "key" : "Luxor",
        "country" : "Egypt"
    }, {
        "key" : "Ankara",
        "country" : "Turkey"
    }, {
        "key" : "Mwanza",
        "country" : "Tanzania"
    }, {
        "key" : "Murmansk",
        "country" : "Russia"
    }, {
        "key" : "Nicosia",
        "country" : "Cyprus"
    }, {
        "key" : "Lilongwe",
        "country" : "Malawi"
    }, {
        "key" : "Simferopol",
        "country" : "Ukraine"
    }, {
        "key" : "Gaza",
        "country" : "Palestine"
    }, {
        "key" : "Mersin",
        "country" : "Turkey"
    }, {
        "key" : "Tel Aviv",
        "country" : "Israel"
    }, {
        "key" : "Blantyre",
        "country" : "Malawi"
    }, {
        "key" : "Jerusalem",
        "country" : "Israel"
    }, {
        "key" : "Adana",
        "country" : "Turkey"
    }, {
        "key" : "Beirut",
        "country" : "Lebanon"
    }, {
        "key" : "Dodoma",
        "country" : "Tanzania"
    }, {
        "key" : "Amman",
        "country" : "Jordan"
    }, {
        "key" : "Damascus",
        "country" : "Syria"
    }, {
        "key" : "Kharkiv",
        "country" : "Ukraine"
    }, {
        "key" : "Nairobi",
        "country" : "Kenya"
    }, {
        "key" : "Gaziantep",
        "country" : "Turkey"
    }, {
        "key" : "Moscow",
        "country" : "Russia"
    }, {
        "key" : "Addis Ababa",
        "country" : "Ethiopia"
    }, {
        "key" : "Asmara",
        "country" : "Eritrea"
    }, {
        "key" : "Jeddah",
        "country" : "Saudi Arabia"
    }, {
        "key" : "Zanzibar City",
        "country" : "Tanzania"
    }, {
        "key" : "Medina",
        "country" : "Saudi Arabia"
    }, {
        "key" : "Mecca",
        "country" : "Saudi Arabia"
    }, {
        "key" : "Sukhumi",
        "country" : "Georgia"
    }, {
        "key" : "Moroni",
        "country" : "Comoros"
    }, {
        "key" : "Baghdad",
        "country" : "Iraq"
    }, {
        "key" : "Hargeisa",
        "country" : "Somalia"
    }, {
        "key" : "Yerevan",
        "country" : "Armenia"
    }, {
        "key" : "Tbilisi",
        "country" : "Georgia"
    }, {
        "key" : "Mamoudzou",
        "country" : "Mayotte"
    }, {
        "key" : "Mogadishu",
        "country" : "Somalia"
    }, {
        "key" : "Tabriz",
        "country" : "Iran"
    }, {
        "key" : "Riyadh",
        "country" : "Saudi Arabia"
    }, {
        "key" : "Stepanakert",
        "country" : "Azerbaijan"
    }, {
        "key" : "Antananarivo",
        "country" : "Madagascar"
    }, {
        "key" : "Basra",
        "country" : "Iraq"
    }, {
        "key" : "Baku",
        "country" : "Azerbaijan"
    }, {
        "key" : "Dammam",
        "country" : "Saudi Arabia"
    }, {
        "key" : "Samara",
        "country" : "Russia"
    }, {
        "key" : "Manama",
        "country" : "Bahrain"
    }, {
        "key" : "Tehran",
        "country" : "Iran"
    }, {
        "key" : "Doha",
        "country" : "Qatar"
    }, {
        "key" : "Abu Dhabi",
        "country" : "United Arab Emirates"
    }, {
        "key" : "Dubai",
        "country" : "United Arab Emirates"
    }, {
        "key" : "Saint-Denis",
        "country" : "Réunion"
    }, {
        "key" : "Perm",
        "country" : "Russia"
    }, {
        "key" : "Port Louis",
        "country" : "Mauritius"
    }, {
        "key" : "Ashgabat",
        "country" : "Turkmenistan"
    }, {
        "key" : "Muscat",
        "country" : "Oman"
    }, {
        "key" : "Nukus",
        "country" : "Uzbekistan"
    }, {
        "key" : "Mashhad",
        "country" : "Iran"
    }, {
        "key" : "Yekaterinburg",
        "country" : "Russia"
    }, {
        "key" : "Kandahar",
        "country" : "Afghanistan"
    }, {
        "key" : "Karachi",
        "country" : "Pakistan"
    }, {
        "key" : "Hyderabad",
        "country" : "India"
    }, {
        "key" : "Dushanbe",
        "country" : "Tajikistan"
    }, {
        "key" : "Kabul",
        "country" : "Afghanistan"
    }, {
        "key" : "Tashkent",
        "country" : "Uzbekistan"
    }, {
        "key" : "Astana",
        "country" : "Kazakhstan"
    }, {
        "key" : "Multan",
        "country" : "Pakistan"
    }, {
        "key" : "Peshawar",
        "country" : "Pakistan"
    }, {
        "key" : "Namangan",
        "country" : "Uzbekistan"
    }, {
        "key" : "Ahmedabad",
        "country" : "India"
    }, {
        "key" : "Mumbai",
        "country" : "India"
    }, {
        "key" : "Surat",
        "country" : "India"
    }, {
        "key" : "Faisalabad",
        "country" : "Pakistan"
    }, {
        "key" : "Rawalpindi",
        "country" : "Pakistan"
    }, {
        "key" : "Islamabad",
        "country" : "Pakistan"
    }, {
        "key" : "Omsk",
        "country" : "Russia"
    }, {
        "key" : "Pune",
        "country" : "India"
    }, {
        "key" : "Lahore",
        "country" : "Pakistan"
    }, {
        "key" : "Bishkek",
        "country" : "Kyrgyzstan"
    }, {
        "key" : "Srinagar",
        "country" : "India"
    }, {
        "key" : "Amritsar",
        "country" : "India"
    }, {
        "key" : "Jaipur",
        "country" : "India"
    }, {
        "key" : "Ludhiana",
        "country" : "India"
    }, {
        "key" : "Almaty",
        "country" : "Kazakhstan"
    }, {
        "key" : "New Delhi",
        "country" : "India"
    }, {
        "key" : "Bangalore",
        "country" : "India"
    }, {
        "key" : "Nagpur",
        "country" : "India"
    }, {
        "key" : "Colombo",
        "country" : "Sri Lanka"
    }, {
        "key" : "Chennai",
        "country" : "India"
    }, {
        "key" : "Kanpur",
        "country" : "India"
    }, {
        "key" : "Kandy",
        "country" : "Sri Lanka"
    }, {
        "key" : "Lucknow",
        "country" : "India"
    }, {
        "key" : "Batticaloa",
        "country" : "Sri Lanka"
    }, {
        "key" : "Novosibirsk",
        "country" : "Russia"
    }, {
        "key" : "Patna",
        "country" : "India"
    }, {
        "key" : "Kathmandu",
        "country" : "Nepal"
    }, {
        "key" : "Ürümqi",
        "country" : "China"
    }, {
        "key" : "Norilsk",
        "country" : "Russia"
    }, {
        "key" : "Gangtok",
        "country" : "India"
    }, {
        "key" : "Shigatse",
        "country" : "China"
    }, {
        "key" : "Thimphu",
        "country" : "Bhutan"
    }, {
        "key" : "Dhaka",
        "country" : "Bangladesh"
    }, {
        "key" : "Lhasa",
        "country" : "China"
    }, {
        "key" : "Agartala",
        "country" : "India"
    }, {
        "key" : "Guwahati",
        "country" : "India"
    }, {
        "key" : "Chittagong",
        "country" : "Bangladesh"
    }, {
        "key" : "Shillong",
        "country" : "India"
    }, {
        "key" : "Port Blair",
        "country" : "India"
    }, {
        "key" : "Dibrugarh",
        "country" : "India"
    }, {
        "key" : "Banda Aceh",
        "country" : "Indonesia"
    }, {
        "key" : "Yangon",
        "country" : "Myanmar"
    }, {
        "key" : "Medan",
        "country" : "Indonesia"
    }, {
        "key" : "Chiang Mai",
        "country" : "Thailand"
    }, {
        "key" : "Surat Thani",
        "country" : "Thailand"
    }, {
        "key" : "Padang",
        "country" : "Indonesia"
    }, {
        "key" : "Hat Yai",
        "country" : "Thailand"
    }, {
        "key" : "Bangkok",
        "country" : "Thailand"
    }, {
        "key" : "Pattaya",
        "country" : "Thailand"
    }, {
        "key" : "Ipoh",
        "country" : "Malaysia"
    }, {
        "key" : "Pekanbaru",
        "country" : "Indonesia"
    }, {
        "key" : "Bratsk",
        "country" : "Russia"
    }, {
        "key" : "Kuala Lumpur",
        "country" : "Malaysia"
    }, {
        "key" : "Xining",
        "country" : "China"
    }, {
        "key" : "Nakhon Ratchasima",
        "country" : "Thailand"
    }, {
        "key" : "Kota Bharu",
        "country" : "Malaysia"
    }, {
        "key" : "Vientiane",
        "country" : "Laos"
    }, {
        "key" : "Kunming",
        "country" : "China"
    }, {
        "key" : "Udon Thani",
        "country" : "Thailand"
    }, {
        "key" : "Johor Bahru",
        "country" : "Malaysia"
    }, {
        "key" : "Lanzhou",
        "country" : "China"
    }, {
        "key" : "Singapore",
        "country" : "Singapore"
    }, {
        "key" : "Siem Reap",
        "country" : "Cambodia"
    }, {
        "key" : "Chengdu",
        "country" : "China"
    }, {
        "key" : "Palembang",
        "country" : "Indonesia"
    }, {
        "key" : "Phnom Penh",
        "country" : "Cambodia"
    }, {
        "key" : "Hanoi",
        "country" : "Vietnam"
    }, {
        "key" : "Chongqing",
        "country" : "China"
    }, {
        "key" : "Hai Phong",
        "country" : "Vietnam"
    }, {
        "key" : "Ho Chi Minh City",
        "country" : "Vietnam"
    }, {
        "key" : "Jakarta",
        "country" : "Indonesia"
    }, {
        "key" : "Bogor",
        "country" : "Indonesia"
    }, {
        "key" : "Ulan Bator",
        "country" : "Mongolia"
    }, {
        "key" : "Bandung",
        "country" : "Indonesia"
    }, {
        "key" : "Da Nang",
        "country" : "Vietnam"
    }, {
        "key" : "Nanning",
        "country" : "China"
    }, {
        "key" : "Pontianak",
        "country" : "Indonesia"
    }, {
        "key" : "Kuching",
        "country" : "Malaysia"
    }, {
        "key" : "Semarang",
        "country" : "Indonesia"
    }, {
        "key" : "Taiyuan",
        "country" : "China"
    }, {
        "key" : "Malang",
        "country" : "Indonesia"
    }, {
        "key" : "Surabaya",
        "country" : "Indonesia"
    }, {
        "key" : "Guangzhou",
        "country" : "China"
    }, {
        "key" : "Macau",
        "country" : "Macau"
    }, {
        "key" : "Zhengzhou",
        "country" : "China"
    }, {
        "key" : "Dongguan",
        "country" : "China"
    }, {
        "key" : "Miri",
        "country" : "Malaysia"
    }, {
        "key" : "Shenzhen",
        "country" : "China"
    }, {
        "key" : "Hong Kong",
        "country" : "Hong Kong"
    }, {
        "key" : "Wuhan",
        "country" : "China"
    }, {
        "key" : "Handan",
        "country" : "China"
    }, {
        "key" : "Shijiazhuang",
        "country" : "China"
    }, {
        "key" : "Bandar Seri Begawan",
        "country" : "Brunei"
    }, {
        "key" : "Denpasar",
        "country" : "Indonesia"
    }, {
        "key" : "Mandurah",
        "country" : "Australia"
    }, {
        "key" : "Perth",
        "country" : "Australia"
    }, {
        "key" : "Kota Kinabalu",
        "country" : "Malaysia"
    }, {
        "key" : "Beijing",
        "country" : "China"
    }, {
        "key" : "Balikpapan",
        "country" : "Indonesia"
    }, {
        "key" : "Jinan",
        "country" : "China"
    }, {
        "key" : "Tianjin",
        "country" : "China"
    }, {
        "key" : "Port Hedland",
        "country" : "Australia"
    }, {
        "key" : "Nanjing",
        "country" : "China"
    }, {
        "key" : "Makassar",
        "country" : "Indonesia"
    }, {
        "key" : "Hangzhou",
        "country" : "China"
    }, {
        "key" : "Kaohsiung",
        "country" : "Taiwan"
    }, {
        "key" : "Qingdao",
        "country" : "China"
    }, {
        "key" : "Taichung",
        "country" : "Taiwan"
    }, {
        "key" : "Manila",
        "country" : "Philippines"
    }, {
        "key" : "Quezon City",
        "country" : "Philippines"
    }, {
        "key" : "Shanghai",
        "country" : "China"
    }, {
        "key" : "Taipei",
        "country" : "Taiwan"
    }, {
        "key" : "Dalian",
        "country" : "China"
    }, {
        "key" : "Iloilo City",
        "country" : "Philippines"
    }, {
        "key" : "Zamboanga City",
        "country" : "Philippines"
    }, {
        "key" : "Shenyang",
        "country" : "China"
    }, {
        "key" : "Tagbilaran",
        "country" : "Philippines"
    }, {
        "key" : "Cebu City",
        "country" : "Philippines"
    }, {
        "key" : "Changchun",
        "country" : "China"
    }, {
        "key" : "Dili",
        "country" : "Mali"
    }, {
        "key" : "Pyongyang",
        "country" : "North Korea"
    }, {
        "key" : "Davao City",
        "country" : "Philippines"
    }, {
        "key" : "Kaesong",
        "country" : "North Korea"
    }, {
        "key" : "Harbin",
        "country" : "China"
    }, {
        "key" : "Incheon",
        "country" : "South Korea"
    }, {
        "key" : "Seoul",
        "country" : "South Korea"
    }, {
        "key" : "Wonsan",
        "country" : "North Korea"
    }, {
        "key" : "Okinawa",
        "country" : "Japan"
    }, {
        "key" : "Ambon",
        "country" : "Indonesia"
    }, {
        "key" : "Daegu",
        "country" : "South Korea"
    }, {
        "key" : "Busan",
        "country" : "South Korea"
    }, {
        "key" : "Yakutsk",
        "country" : "Russia"
    }, {
        "key" : "Chongjin",
        "country" : "North Korea"
    }, {
        "key" : "Fukuoka",
        "country" : "Japan"
    }, {
        "key" : "Darwin",
        "country" : "Australia"
    }, {
        "key" : "Vladivostok",
        "country" : "Russia"
    }, {
        "key" : "Hiroshima",
        "country" : "Japan"
    }, {
        "key" : "Melekeok",
        "country" : "Palau"
    }, {
        "key" : "Kobe",
        "country" : "Japan"
    }, {
        "key" : "Osaka",
        "country" : "Japan"
    }, {
        "key" : "Kyoto",
        "country" : "Japan"
    }, {
        "key" : "Nagoya",
        "country" : "Japan"
    }, {
        "key" : "Adelaide",
        "country" : "Australia"
    }, {
        "key" : "Yokohama",
        "country" : "Japan"
    }, {
        "key" : "Kawasaki",
        "country" : "Japan"
    }, {
        "key" : "Jayapura",
        "country" : "Indonesia"
    }, {
        "key" : "Sapporo",
        "country" : "Japan"
    }, {
        "key" : "Geelong",
        "country" : "Australia"
    }, {
        "key" : "Hagåtña",
        "country" : "United States"
    }, {
        "key" : "Dededo",
        "country" : "United States"
    }, {
        "key" : "Melbourne",
        "country" : "Australia"
    }, {
        "key" : "Saipan",
        "country" : "United States"
    }, {
        "key" : "Cairns",
        "country" : "Australia"
    }, {
        "key" : "Townsville",
        "country" : "Australia"
    }, {
        "key" : "Port Moresby",
        "country" : "Papua New Guinea"
    }, {
        "key" : "Hobart",
        "country" : "Australia"
    }, {
        "key" : "Canberra",
        "country" : "Australia"
    }, {
        "key" : "Rockhampton",
        "country" : "Australia"
    }, {
        "key" : "Magadan",
        "country" : "Russia"
    }, {
        "key" : "Wollongong",
        "country" : "Australia"
    }, {
        "key" : "Sydney",
        "country" : "Australia"
    }, {
        "key" : "Newcastle",
        "country" : "United Kingdom"
    }, {
        "key" : "Weno",
        "country" : "Federated States of Micronesia"
    }, {
        "key" : "Brisbane",
        "country" : "Australia"
    }, {
        "key" : "Gold Coast",
        "country" : "Australia"
    }, {
        "key" : "Palikir",
        "country" : "Federated States of Micronesia"
    }, {
        "key" : "Honiara",
        "country" : "Solomon Islands"
    }, {
        "key" : "Nouméa",
        "country" : "New Caledonia"
    }, {
        "key" : "Invercargill",
        "country" : "New Zealand"
    }, {
        "key" : "Dunedin",
        "country" : "New Zealand"
    }, {
        "key" : "Majuro",
        "country" : "Marshall Islands"
    }, {
        "key" : "Christchurch",
        "country" : "New Zealand"
    }, {
        "key" : "Wellington",
        "country" : "New Zealand"
    }, {
        "key" : "Napier",
        "country" : "New Zealand"
    }, {
        "key" : "Hamilton",
        "country" : "New Zealand"
    }, {
        "key" : "Dunedin",
        "country" : "New Zealand"
    }, {
        "key" : "Tauranga",
        "country" : "New Zealand"
    }, {
        "key" : "Taupo",
        "country" : "New Zealand"
    }, {
        "key" : "Auckland",
        "country" : "New Zealand"
    }, {
        "key" : "Suva",
        "country" : "Fiji"
    }, {
        "key" : "Funafuti",
        "country" : "Tuvalu"
    }, {
        "key" : "Labasa",
        "country" : "Fiji"
    }, {
        "key" : "Nukuʻalofa",
        "country" : "Tonga"
    }, {
        "key" : "Rabi Island",
        "country" : ""
    }, {
        "key" : "St. Louis",
        "country" : "United States"
    }, {
        "key" : "Santiago de Cuba",
        "country" : "Cuba"
    }, {
        "key" : "New York City",
        "country" : "United States"
    }, {
        "key" : "Port-au-Prince",
        "country" : "Haiti"
    }, {
        "key" : "San Carlos de Bariloche",
        "country" : "Argentina"
    }, {
        "key" : "Quebec City",
        "country" : "Canada"
    }, {
        "key" : "City of Halifax",
        "country" : "Canada"
    }, {
        "key" : "Santa Cruz de la Sierra",
        "country" : "Bolivia"
    }, {
        "key" : "St. George's",
        "country" : "Grenada"
    }, {
        "key" : "Port of Spain",
        "country" : "Trinidad and Tobago"
    }, {
        "key" : "Fort-de-France",
        "country" : "Martinique"
    }, {
        "key" : "Ciudad del Este",
        "country" : "Argentina"
    }, {
        "key" : "São José dos Campos",
        "country" : "Brazil"
    }, {
        "key" : "Rio de Janeiro",
        "country" : "Brazil"
    }, {
        "key" : "Horta (Azores)",
        "country" : "Portugal"
    }, {
        "key" : "Angra do Heroísmo",
        "country" : "Portugal"
    }, {
        "key" : "Santa Cruz de Tenerife",
        "country" : "Spain"
    }, {
        "key" : "Las Palmas de Gran Canaria",
        "country" : "Spain"
    }, {
        "key" : "Cork (city)",
        "country" : "Ireland"
    }, {
        "key" : "Marrakech",
        "country" : "Morocco"
    }, {
        "key" : "Andorra la Vella",
        "country" : "Andorra"
    }, {
        "key" : "Luxembourg (city)",
        "country" : "Luxembourg"
    }, {
        "key" : "City of San Marino",
        "country" : "San Marino"
    }, {
        "key" : "Vatican City",
        "country" : ""
    }, {
        "key" : "Split (city)",
        "country" : "Croatia"
    }, {
        "key" : "Gdańsk",
        "country" : "Poland"
    }, {
        "key" : "Thessaloniki",
        "country" : "Greece"
    }, {
        "key" : "İzmir",
        "country" : "Turkey"
    }, {
        "key" : "Chişinău",
        "country" : "Moldova"
    }, {
        "key" : "Kiev",
        "country" : "Ukraine"
    }, {
        "key" : "Dar es Salaam",
        "country" : "Tanzania"
    }, {
        "key" : "Djibouti (city)",
        "country" : "Djibouti"
    }, {
        "key" : "Tskhinvali",
        "country" : "Georgia"
    }, {
        "key" : "Sana'a",
        "country" : "Yemen"
    }, {
        "key" : "Nizhny Novgorod",
        "country" : "Russia"
    }, {
        "key" : "Arbil",
        "country" : "Iraq"
    }, {
        "key" : "Kuwait City",
        "country" : "Kuwait"
    }, {
        "key" : "Malé",
        "country" : "Republic of Maldives"
    }, {
        "key" : "Sri Jayawardenapura-Kotte",
        "country" : "Sri Lanka"
    }, {
        "key" : "Kolkata",
        "country" : "India"
    }, {
        "key" : "Naypyidaw",
        "country" : ""
    }, {
        "key" : "Phuket (city)",
        "country" : "Thailand"
    }, {
        "key" : "Alor Star",
        "country" : "Malaysia"
    }, {
        "key" : "Malacca Town",
        "country" : "Malaysia"
    }, {
        "key" : "Huế",
        "country" : "Vietnam"
    }, {
        "key" : "Xi'an",
        "country" : "China"
    }, {
        "key" : "Yogyakarta (city)",
        "country" : "Indonesia"
    }, {
        "key" : "Makati City",
        "country" : "Philippines"
    }, {
        "key" : "Koror",
        "country" : "Republic of Palau"
    }, {
        "key" : "Tokyo",
        "country" : "Japan"
    }, {
        "key" : "Petropavlovsk-Kamchatsky",
        "country" : "Russia"
    }, {
        "key" : "Yaren District",
        "country" : "Nauru"
    }, {
        "key" : "Port Vila",
        "country" : "Vanuatu"
    }, {
        "key" : "South Tarawa",
        "country" : ""
    }, {
        "key" : "Mata-Utu",
        "country" : "Wallis and Futuna"
    }, {
        "key" : "Anadyr (town)",
        "country" : ""
    }, {
        "key" : "Nukulaelae",
        "country" : ""
    }
];



// WEBPACK FOOTER //
// ./client/js/config/cities-with-countries.js